/**
 * Selectors for the head tags that are owned by route-level `head` +
 * `<HeadContent />`. Prerendered pages ship a static copy of these tags so
 * crawlers see them without JS. On a real browser load we strip the static
 * copies before React mounts, so the client re-injects exactly one of each
 * (no duplicate title/description/canonical/JSON-LD after mount).
 *
 * `application/ld+json` scripts are included only for landing pages (injected
 * via `buildHead`); do not add third-party JSON-LD elsewhere — it would be
 * stripped here and never restored.
 *
 * The `robots` meta is intentionally NOT listed: it is owned by the static
 * shell / prerender rewrite, not by `head`.
 */
const MANAGED_HEAD_SELECTORS = [
  'title',
  'meta[name="description"]',
  'meta[property^="og:"]',
  'meta[name^="twitter:"]',
  'link[rel="canonical"]',
  'link[rel="alternate"]',
  'script[type="application/ld+json"]',
] as const

export function resetManagedHead(): void {
  if (typeof document === 'undefined') {
    return
  }

  const selector = MANAGED_HEAD_SELECTORS.join(',')
  document.head.querySelectorAll(selector).forEach((element) => {
    element.remove()
  })
}
